import React from 'react';
import { CTAButton } from './CTAButton';
import { Stars } from './Stars';
import { PRODUCT_IMAGE, scrollToCheckout } from '../lib/data';
const badges = ['📄 100% PDF', '⚡️ Entrega Inmediata', '💳 Pago Único'];
export function Hero() {
  return <section className="px-4 pb-8 pt-8" data-id="element-138" data-mp="9l37jlcn0s87">
      <h1 className="text-center font-display text-3xl leading-[1.05] text-white sm:text-4xl" data-id="element-139" data-mp="4m8msdv40tlg">
        El Sistema Completo para Rendir al Máximo en Cada Partido de{' '}
        <span className="text-hockey-pink" data-id="element-140" data-mp="1274p5sdm9m8t">Hockey Sobre Césped</span>
      </h1>

      <button type="button" onClick={scrollToCheckout} className="mt-6 block w-full overflow-hidden rounded-3xl border border-white/10 bg-black/40 shadow-2xl" aria-label="Ver oferta de Hockey Pro System" data-id="element-141" data-mp="xb5rtfab8tw9">
        <img src={PRODUCT_IMAGE} alt="Hockey Pro System — 6 tomos completos y 8 bonos exclusivos" className="w-full" data-id="element-142" data-mp="3d21rzwjzqin7" />
      </button>

      <p className="mt-6 text-center text-base font-medium text-white/80" data-id="element-143" data-mp="381nvnbrr4x50">
        360 páginas de contenido + planillas y calculadoras listas para aplicar desde hoy.
      </p>

      <div className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-144" data-mp="3o7vjnj38jlwr">
        {badges.map(b => <span key={b} className="rounded-full border border-hockey-pink/30 bg-hockey-card px-3 py-1.5 text-[13px] font-bold text-white" data-id="element-145" data-mp="399bavmrkdbvg">
            {b}
          </span>)}
      </div>

      <div className="mt-6" data-id="element-146" data-mp="30gq6jbooj7q5">
        <CTAButton label="Quiero dominar los partidos" data-id="element-147" data-mp="358re4kawka9u" />
      </div>

      <div className="mt-5 flex items-center justify-center gap-2.5" data-id="element-148" data-mp="35a2ial89fk1h">
        <Stars size={22} data-id="element-149" data-mp="2qkwj2x9f9ttl" />
        <span className="text-lg font-extrabold text-white" data-id="element-150" data-mp="2qloea6z3xpjc">4.9/5</span>
        <span className="text-sm font-semibold text-white/60" data-id="element-151" data-mp="2vjzmyedo1tzz">· +1.200 jugadoras</span>
      </div>
    </section>;
}